<template>
  <div>
    <div class="col-md-12">
      <div class="col-md-4">
        <div class="mb-3">
          <label>Συσκευές</label>
          <b-spinner
            v-show="spinner"
            class="m-2"
            variant="primary"
            role="status"
          ></b-spinner>
          <b-alert
            v-show="alert.alertShow"
            show
            dismissible
            :variant="alert.alertVariant"
            >{{ alert.alertMsg }}</b-alert
          >
          <multiselect
            :disabled="checkBox == 'accepted' ? true : false"
            v-model="syncDeviceName"
            :options="deviceNames"
            placeholder="Επιλέξτε Συσκευή"
            selectLabel="Eπιλογή Συσκευή"
            selectedLabel="Επιλέχθηκε"
            deselectLabel="Αποεπιλογή"
          ></multiselect>
        </div>
      </div>
      <b-form-checkbox
        value="accepted"
        unchecked-value="not_accepted"
        class="mb-3"
        v-model="checkBox"
        plain
        >Συγχρονισμός σε όλα τα μηχανήματα
      </b-form-checkbox>
    </div>
    <button class="btn btn-primary" @click.prevent="synchronize">
      Συγχρονισμός
    </button>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import session from "../../../../../api/session";
import { eventCreate } from "../../../../../eventspy";
export default {
  components: {
    Multiselect,
  },
  props: {
    devices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      checkBox: "accepted",
      syncDeviceName: "",
      spinner: false,
      alert: {
        alertShow: false,
        alertVariant: "",
        alertMsg: "",
      },
    };
  },
  computed: {
    deviceNames() {
      return this.devices.map((e) => e.device_name);
    },
  },
  methods: {
    synchronize() {
      if (this.checkBox === "accepted") {
        this.syncronizeAllDevices();
      } else {
        this.synchonizeDevice();
      }
    },
    async syncronizeAllDevices() {
      this.spinner = true;
      await session
        .get("api/synchronization/?device=all")
        .then(() => {
          this.spinner = false;

          this.alert.alertShow = true;
          this.alert.alertVariant = "success";
          this.alert.alertMsg = "Eπιτυχής συγχρονισμός";
          eventCreate(`Εγινε συγχρονισμός σε ολες τις συσκευές`, 2);

          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
        })
        .catch((e) => {
          this.alert.alertShow = true;
          this.alert.alertVariant = "danger";
          this.alert.alertMsg = e.response.data;

          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
        });
    },
    async synchonizeDevice() {
      if (this.syncDeviceName === "" || this.syncDeviceName == null) {
        this.alert.alertShow = true;
        this.alert.alertVariant = "danger";
        this.alert.alertMsg = "Παρακαλώ επιλέξτε συσκευή";
        setTimeout(() => {
          this.alert.alertShow = false;
        }, 2000);
        return;
      }
      this.spinner = true;
      await session
        .get(`api/synchronization/?device=${this.syncDeviceName}`)
        .then(() => {
          this.spinner = false;

          this.alert.alertShow = true;
          this.alert.alertVariant = "success";
          this.alert.alertMsg = "Eπιτυχής συγχρονισμός";
          eventCreate(`Εγινε συγχρονισμός σε ολες τις συσκευές`, 2);

          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
        })
        .catch((e) => {
          this.alert.alertShow = true;
          this.alert.alertVariant = "danger";
          this.alert.alertMsg = e.response.data;

          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
        });
    },
  },
};
</script>
